var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn"},[_c('img',{attrs:{"src":"http://img.wish.hebyun.com.cn/images/update_bg.png"}}),_c('span',[_vm._v(_vm._s(_vm.button))])])}
var staticRenderFns = []

export { render, staticRenderFns }